function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { FieldBase } from "./FieldBase";
import PropTypes from "prop-types";
import React from "react";
import InputRange from "react-input-range"; // #region HOOK

/**
 * Représente un champ de saisie d'un intervalle à l'aide d'un slider
 * @class
 * @category Fields
 * @param {Fields.RangeField.propTypes} props Les propriétés du composant
 */

function RangeField(props) {
  // Récupération des props
  var readonly = props.readonly,
      max = props.max,
      min = props.min,
      name = props.name,
      step = props.step,
      unite = props.unite,
      value = props.value; // Fonction appelée lors du changement de valeur

  var internalHandleChange = function internalHandleChange(value, handleChange) {
    if (handleChange) {
      // On construit l'event "à la main"
      var event = {
        target: {
          type: "range",
          name: name,
          value: value
        }
      };
      handleChange(event);
    }
  };

  return /*#__PURE__*/React.createElement(FieldBase, _extends({}, props, {
    render: function render(handleChange) {
      return /*#__PURE__*/React.createElement(InputRange, {
        name: name,
        value: value,
        minValue: min,
        maxValue: max,
        step: step,
        formatLabel: function formatLabel(value) {
          return "" + value + unite;
        },
        onChange: function onChange(value) {
          return internalHandleChange(value, handleChange);
        },
        readonly: readonly
      });
    }
  }));
} // #endregion
// #region PROPRIETES

/**
 * Type des propriétés de {@link RangeField}
 * @typedef {Object} RangeField.propTypes
 * @property {string} name Le nom du champ
 * @property {string} tooltip Le texte du champ
 * @property {string} [width=100%] La largeur du champ
 * @property {string} [backgroundColor=#fff] La couleur de fond
 * @property {string} [textColor=#000] La couleur du texte
 * @property {object} [value={ min: 0, max: 100 }] Un objet contenant les valeurs sélectionnées
 * @property {number} [min=0] La valeur minimale
 * @property {number} [max=100] La valeur maximale
 * @property {number} [step=1] Le pas
 * @property {string} [unite] L'unité
 * @property {string} [icon=null] L'icône
 * @property {boolean} [keepSpaceIcon=false] true pour maintenir un écart vide si pas d'icône lorsqu'on empile des champs
 * @property {function} [onClickIcon=null] La fonction de callback de l'évènement onClick de l'icône
 * @property {function} [onMouseEnterIcon=null] La fonction de callback de l'évènement onMouseEnter de l'icône
 * @property {boolean} [obligatory=false] true pour rendre le champ obligatoire
 * @property {boolean} [readonly=false] true pour désactiver le champ
 */


RangeField.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
  width: PropTypes.string,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  value: PropTypes.object,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  unite: PropTypes.string,
  icon: PropTypes.string,
  keepSpaceIcon: PropTypes.bool,
  onClickIcon: PropTypes.func,
  onMouseEnterIcon: PropTypes.func,
  obligatory: PropTypes.bool,
  readonly: PropTypes.bool
} : {};
/*
  Valeurs par défaut des propriétés
*/

RangeField.defaultProps = {
  width: "100%",
  backgroundColor: "#fff",
  textColor: "#000",
  value: {
    min: 0,
    max: 100
  },
  min: 0,
  max: 100,
  step: 1,
  unite: "",
  icon: null,
  keepSpaceIcon: false,
  onClickIcon: null,
  onMouseEnterIcon: null,
  obligatory: false,
  readonly: false
}; // #endregion

export { RangeField };